import React, {useMemo, useState} from 'react';
import Form, {FormInputComponent} from "../../components/form/Form";
import {useAuth} from "../../providers/AuthProvider";
import {Select} from 'antd';
import {usePositionOverride} from "../../providers/PositionOverrideProvider";
import {usePosition} from "../../providers/ProjectPositionProvider";
import SpinLoader from "../../components/SpinLoader";
import {useAPI} from "../../config/API";
import {useProject} from "../../providers/ClientProjectProvider";

const PositionCandidateGreenlightOptionsModal = ({onClose}) => {
    const {auth} = useAuth();
    const {project} = useProject();
    const {position} = usePosition();
    const {linkGreenlightJobToCandidate, isDisabled} = usePositionOverride();
    const candidate = position.assigned_candidate;

    const [greenlightId, setGreenlightId] = useState(null)
    const {
        data: glOptions,
        error,
        isLoading
    } = useAPI(['fetchGreenlightOptionsForCandidate', {position_id: position.id, project_id: project.id}], {
        onSuccess: (response) => {
            console.log('onSuccess', response)
        }
    })

    const placeHolderOption = {label: 'Please select an option...', value: false, disabled:true};
    const greenLightOptions = useMemo(() => {
        if (isLoading || !glOptions || !TB.keys(glOptions)?.length) {
            return []
        }
        return [placeHolderOption,...TB.map(glOptions,
            (label, id) => {
                return {
                    label: (<span dangerouslySetInnerHTML={{__html: label}} />),
                    value: id
                }
            })]
    }, [glOptions, isLoading]);

    console.log('PositionCandidateGreenlightOptionsModal', greenLightOptions)
    return (
        <SpinLoader isLoading={isDisabled}>
            <div>

                <React.Fragment>
                    <div>
                        <p className="my-3">
                            Use the options below to match the existing Greenlight job
                        </p>
                    </div>
                    <Form
                        background={'transparent'}
                        onChange={({greenlight_id}) => {

                            setGreenlightId(greenlight_id);
                        }}
                        minimal
                        disabled={isDisabled}
                        onSubmit={async () => {
                            let response = await linkGreenlightJobToCandidate(greenlightId);
                            if (response) {
                                TB.toast("Greenlight Job successfully linked", {type: 'success'});
                                return onClose();
                            }

                        }}
                        submitButton={false}
                        model={{greenlight_id: greenlightId}}
                    >
                            <FormInputComponent
                                type="antd-input"
                                value={greenlightId || false}
                                fieldName="greenlight_id"
                                label="Greenlight Job"
                                placeholder="Select an option..."
                                required={true}>

                                <Select loading={isLoading} options={greenLightOptions}/>

                            </FormInputComponent>



                        <div className="flex mt-5 flex-row justify-end gap-3">

                            <button
                                type="button" disabled={isDisabled}
                                className="btn btn-outline-dark" onClick={onClose}>
                                Cancel
                            </button>

                            <button
                                type="submit"
                                disabled={isDisabled}
                                className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </Form>
                </React.Fragment>

            </div>
        </SpinLoader>
    );
}

export default PositionCandidateGreenlightOptionsModal;